import script from "./ActionDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionDropdown.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"ActionDropdown.vue"]])

export default __exports__